import { DateRangePicker } from '~/@/components/inputs/date/date-range-picker/date-range-picker'
import { CustomFilterInputProps } from './CustomFilterInput'

type RangeFilterInputProps = CustomFilterInputProps & {
  isDateTime?: boolean
}

/**
 * Wrapper component for RangeDatePicker to handle MUI Grid props
 */
export function RangeFilterInput(props: RangeFilterInputProps) {
  const { item, applyValue, disabled, isDateTime } = props

  return (
    <DateRangePicker
      disabled={disabled}
      isDateTime={isDateTime}
      onChange={(range) => {
        applyValue({ ...item, value: range })
      }}
      value={item.value}
    />
  )
}
